export default class Errors {

    constructor() {
        this.errors = {}
    }

    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    get(field) {
        if (this.errors[field]) {
            return this.errors[field];
        }
    }

    setErrors(errors) {
        this.errors = errors;
    }

    setOneError(field, error) {
        this.setErrors({...this.errors, ...{ [field]: error } })
    }

    clear(field) {
        if (!!this.errors[field]) {
            this.setErrors(_.omit(this.errors, field));
        }
    }

    clearAll() {
        this.errors = {};
    }

    hasOne() {
        return Object.keys(this.errors).length > 0;
    }
}
